export default "__VITE_ASSET__1dd2c547__"